import '../../style/index.less';
import './index.less';

// style dependencies
import '../../checkbox/style';
import '../../button/style';
import '../../input/style';



// WEBPACK FOOTER //
// ./_antd1.11.2/transfer_browser/style/index.js